import { Component, OnInit } from '@angular/core';
import { MktModalService } from '../../../core/services/mkt-modal.service';
import { MktEnvironmentService } from 'src/app/core/services/mkt-environment.service';
const dummyData = require('./dummyData.json');

@Component({
  selector: 'app-social-network-btns',
  templateUrl: './social-network-btns.component.html',
  styleUrls: ['./social-network-btns.component.scss'],
  standalone: false
})
export class SocialNetworkBtnsComponent implements OnInit {

  socialMediaLinks: any = null;
  isModalOpen: boolean;
  modalTitle: string;
  modalContent: string;
  modalButtonText: string;
  modalUrl: string;
  imagePrefix:string;
  constructor(
    private modalService: MktModalService,
    private mktEnvironmentService: MktEnvironmentService
  ) {
    this.imagePrefix = this.mktEnvironmentService.getEnvironmentVar('cardsmkrHostName');
  }

  ngOnInit() {
    this.socialMediaLinks = dummyData.socialMediaLinks;
  }

  openModal(event, linkIndex) {
    if (!this.socialMediaLinks) return;

    const socialMediaLink = this.socialMediaLinks[linkIndex];
    this.modalService.openModal(event, {
      url: socialMediaLink.modalUrl,
      title: socialMediaLink.modalTitle,
      content: socialMediaLink.modalContent,
      primaryButtonText: socialMediaLink.modalButtonText
    });
  }
}
